import { cn } from "@/lib/utils";

const Q = [
  ["Supportive & Accommodating", "left-0 top-0"], ["Assertive & Collaborative", "right-0 top-0"],
  ["Reserved & Independent", "left-0 bottom-0"], ["Direct & Competitive — may come across as aggressive under pressure", "right-0 bottom-0"],
];

export function StyleMap({ style }) {
  return (
    <section className="panel space-y-3 p-5" data-testid="style-map">
      <div>
        <h3 className="text-base font-semibold">Interpersonal style</h3>
        <p className="text-sm text-ink-secondary">Most likely: <strong data-testid="style-quadrant">{style.quadrant}</strong></p>
      </div>
      <div className="flex gap-2">
        <div className="flex w-4 items-center justify-center"><span className="whitespace-nowrap text-[10px] text-ink-muted [writing-mode:vertical-rl] rotate-180">Teamwork & Cooperation →</span></div>
        <div className="flex-1 space-y-1">
          <div className="relative aspect-square max-h-72 w-full overflow-hidden rounded-[6px] border border-line bg-white">
            <div className="absolute inset-0 grid grid-cols-2 grid-rows-2">
              {[0, 1, 2, 3].map((i) => <div key={i} className={cn("border-line", i % 2 === 0 && "border-r", i < 2 && "border-b", style.quadrant === Q[i][0] && "bg-brand-tint/60")} />)}
            </div>
            {Q.map(([label, pos]) => <span key={label} className={cn("absolute max-w-[46%] p-2 text-[10px] leading-tight text-ink-muted sm:text-[11px]", pos, label.startsWith("Direct") || label.startsWith("Reserved") ? "flex items-end" : "")}>{label}</span>)}
            <div className="absolute h-4 w-4 -translate-x-1/2 translate-y-1/2 rounded-full border-2 border-white bg-brand shadow-md" style={{ left: `${style.x}%`, bottom: `${style.y}%` }} data-testid="style-dot" title={`Assertiveness ${style.x}, Cooperation ${style.y}`} />
          </div>
          <p className="text-center text-[10px] text-ink-muted">Assertiveness →</p>
        </div>
      </div>
    </section>
  );
}
